import React from "react";

// Placeholder component - to be implemented
const AppraisalsForm = () => {
  return (
    <div className="mt-5 p-8 text-center">
      <p className="text-gray-500 dark:text-gray-400">
        Appraisal Form feature coming soon...
      </p>
    </div>
  );
};

export default AppraisalsForm;
